<template>
  <mdb-container>
    <mdb-card class="text-left">
      <mdb-card-body>
        <mdb-btn :disabled="executing" @click="doCancel" rounded size="sm">
          <mdb-icon icon="arrow-left"/>
          Back to Main
        </mdb-btn>
        <div>
          <h6>Broadcast To</h6>
          <select class="browser-default custom-select" id="broadcast-target" v-model="broadcast.target">
            <option value="Going">{{capitalize($t('common.label.going'))}}</option>
            <option value="Waiting">Waiting</option>
            <option value="Both Going and Waiting">Both {{capitalize($t('common.label.going'))}} and Waiting</option>
          </select>
        </div>
        <mdb-row>
          <mdb-col col="3">
            <mdb-input id="direct-reply"
                       label="Allow direct e-mail reply"
                       name="direct-reply"
                       type="checkbox"
                       v-model="broadcast.allowDirect"/>
          </mdb-col>
          <mdb-col col="8" v-if="broadcast.allowDirect">
            <mdb-input label="From" type="text" v-model="broadcast.senderEmail"/>
          </mdb-col>
        </mdb-row>
        <editor :init="editorConfig" v-model="broadcast.text"/>

        <div>
          <small>
            Internal notifications are sent within 15 minutes. Emails/push notifications will be sent out based on each
            member's
            preferences. Some members may opt out of external notifications altogether.
          </small>
        </div>
        <div v-if="group.approved">
          <mdb-btn :disabled="!broadcast.text || (!broadcast.senderEmail && broadcast.allowDirect)" @click="doSend"
                   color="success"
                   icon="times-circle">Send
          </mdb-btn>
        </div>
        <div v-if="!group.approved" class="text-info small">
          This feature is disabled until your group is approved.
        </div>

      </mdb-card-body>
    </mdb-card>
  </mdb-container>

</template>

<script>
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChipInput,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbInputGroup,
  mdbRow
} from 'mdbvue';
import api from "../../services/groupsPlaceApi";
import editor from '@tinymce/tinymce-vue'
import bannerSmall from "../group/BannerSmall";

export default {
  name: 'Event-Notification',
  components: {
    mdbContainer,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbIcon,
    mdbInput,
    mdbInputGroup,
    mdbRow,
    mdbCol,
    mdbChipInput,
    bannerSmall,
    mdbBadge,
    editor
  },
  props: {
    event: {
      type: Object,
      default: []
    }
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    },
    group() {
      return this.$store.state.currentGroup
    },
    settings() {
      return this.$store.state.settings
    },
    executing() {
      return this.$store.state.executing
    }
  },
  mounted() {
    document.title = "Broadcast Message"
    this.broadcast.senderEmail = this.userDetails.email
  },
  data() {
    return {
      broadcast: {
        target: "Going",
        allowDirect: false,
        senderEmail: null,
        text: ""
      },
      editorConfig: {
        browser_spellcheck: true,
        branding: false,
        plugins: ["image", "link", "code", "paste", "table", "lists"],
        toolbar: ["undo redo cut copy paste bold italic underline numlist bullist fontsizeselect | alignleft alignright aligncenter | styleselect | link unlink code "],
        style_formats_merge: true,
        paste_as_text: true,
        paste_data_images: false,
        relative_urls: false,
        remove_script_host: false,
        height: 400
      }
    }
  },
  methods: {
    doSend() {
      api.post("/event/broadcast/" + this.event.eventId, this.broadcast).then(
          (results) => {
            this.$notify.success({
                                   message: "Your message has been queued for delivery.",
                                   timeOut: 5000
                                 })
            this.$emit("close")
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 5000})
          }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doCancel() {
      this.$emit("close")
    }
  }
}
;
</script>
